var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconApple = function SvgIconApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-apple_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F9",
    fillRule: "evenodd",
    d: "M12.895 2.734S11.568 2.74 10.613 4c-.85 1.119-.633 2.076-.633 2.076s1.151.199 2.164-1.018c.948-1.14.751-2.323.751-2.323m-2.032 3.94c-.312.126-.57.23-.761.23-.24 0-.53-.112-.866-.241-.466-.18-1.022-.394-1.661-.394-1.693 0-3.498 1.516-3.498 4.406 0 2.937 2.132 6.59 3.82 6.59.263 0 .588-.117.949-.248.448-.162.951-.345 1.457-.345.453 0 .846.147 1.233.292.378.141.751.28 1.17.28 1.849 0 3.217-3.851 3.217-3.851s-1.958-.759-1.958-2.958c0-1.95 1.572-2.753 1.572-2.753s-.804-1.453-2.846-1.453c-.722 0-1.342.25-1.828.445",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconApple;